import type { Locale } from 'date-fns';
import { format, formatDistanceToNow, isSameDay } from 'date-fns';

export const computeTreatmentDateAndOpportunityString = (
  estimatedVisitDate: Date,
  isCondensed?: boolean,
  locale?: Locale,
) => {
  if (!estimatedVisitDate) {
    return '';
  }

  let imageDateString = `${format(estimatedVisitDate, 'P', {
    locale: locale,
  })}`;
  if (isCondensed) {
    return imageDateString;
  }
  if (isSameDay(estimatedVisitDate, new Date())) {
    imageDateString = formatDistanceToNow(new Date(), {
      includeSeconds: false,
      locale: locale,
      addSuffix: true,
    }).toUpperCase();
  }

  return imageDateString;
};
